export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const COMPANY = {
  name: "PayNoMoreFees.com",
  shortName: "PayNoMoreFees.com",
  legalName: "The Faour Group LLC",
  logo: "/faour-logo.png",
  website: "PayNoMoreFees.com",
  websiteUrl: "https://www.paynomorefees.com",
  phone: "(407) 394-4254",
  phoneHref: "tel:+14073944254",
  email: "info@paynomorefees.com",
};
